import { get, getRawValue } from '../../utils/get';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { IDENTIFIERS } from '../../types/Identifiers';
import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { getProductFullUrl } from './calculated/get-product-full-url';
var IDs = {
    SITE_NAME: 'site.name',
    SITE_URL: 'site.url',
    BUSINESS_NAME: 'site.business.name',
    INDEX_SITE: 'site.index',
    INDEX_PAGE: 'page.index',
    ID: 'product.id',
    SKU: 'product.sku',
    NAME: 'product.name',
    DESCRIPTION: 'product.description',
    PRICE: 'product.price',
    CURRENCY: 'product.currency',
    TYPE: 'product.type',
    WEIGHT: 'product.weight',
    AVAILABILITY_SCHEMA: 'product.availability.schema',
    AVAILABILITY_META_TAG: 'product.availability.metaTag',
    SLUG: 'product.slug',
    IMAGE_URL: 'product.image.url',
    IMAGE_WIDTH: 'product.image.width',
    IMAGE_HEIGHT: 'product.image.height',
    IMAGE_ALT: 'product.image.alt',
    THUMBNAIL_URL: 'product.thumbnail.url',
    THUMBNAIL_WIDTH: 'product.thumbnail.width',
    THUMBNAIL_HEIGHT: 'product.thumbnail.height',
    THUMBNAIL_ALT: 'product.thumbnail.alt',
    PRODUCT_PAGE_URL: 'product.url',
    PRODUCT_PAGE_BASE_URL: 'product.baseUrl',
    DISABLE_SCHEMA: 'product.disable-schema',
};
var userVisible = [
    IDs.SITE_NAME,
    IDs.SKU,
    IDs.NAME,
    IDs.DESCRIPTION,
    IDs.PRICE,
    IDs.CURRENCY,
    IDs.AVAILABILITY_META_TAG,
    IDs.PRODUCT_PAGE_URL,
    IDs.IMAGE_URL,
];
var userVisibleSdOnly = [
    IDs.IMAGE_HEIGHT,
    IDs.IMAGE_WIDTH,
    IDs.IMAGE_ALT,
    IDs.THUMBNAIL_URL,
    IDs.THUMBNAIL_HEIGHT,
    IDs.THUMBNAIL_WIDTH,
    IDs.THUMBNAIL_ALT,
    IDs.AVAILABILITY_SCHEMA,
    IDs.SITE_URL,
];
var requiredSchemaVariables = [];
var SchemaTypes = {
    STORES_PRODUCT_PAGE: 'stores-product-page-preset',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        return _a = {},
            _a[IDs.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME),
            _a[IDs.SITE_URL] = get(item, "context." + CONTEXT_PROPS.SITE_URL),
            _a[IDs.BUSINESS_NAME] = get(item, "context." + CONTEXT_PROPS.BUSINESS_NAME),
            _a[IDs.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE),
            _a[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE),
            _a[IDs.ID] = get(item, 'product.id'),
            _a[IDs.SKU] = get(item, 'product.sku'),
            _a[IDs.NAME] = get(item, 'product.name'),
            _a[IDs.DESCRIPTION] = get(item, 'product.description'),
            _a[IDs.PRICE] = get(item, 'product.price.discountedPrice') > 0
                ? "" + get(item, 'product.price.discountedPrice')
                : "" + get(item, 'product.price.price'),
            _a[IDs.CURRENCY] = "" + get(item, 'product.price.currency'),
            _a[IDs.TYPE] = get(item, 'product.productType'),
            _a[IDs.WEIGHT] = get(item, 'product.weight'),
            _a[IDs.AVAILABILITY_SCHEMA] = "" + get(item, 'product.stock.inStock') === 'true'
                ? 'https://schema.org/InStock'
                : 'https://schema.org/OutOfStock',
            _a[IDs.AVAILABILITY_META_TAG] = "" + get(item, 'product.stock.inStock') === 'true'
                ? 'InStock'
                : 'out of stock',
            _a[IDs.SLUG] = get(item, 'product.slug'),
            _a[IDs.IMAGE_URL] = get(item, 'product.media.mainMedia.image.url'),
            _a[IDs.IMAGE_WIDTH] = get(item, 'product.media.mainMedia.image.width'),
            _a[IDs.IMAGE_HEIGHT] = get(item, 'product.media.mainMedia.image.height'),
            _a[IDs.IMAGE_ALT] = get(item, 'product.media.mainMedia.image.alt'),
            _a[IDs.THUMBNAIL_URL] = get(item, 'product.media.mainMedia.thumbnail.url'),
            _a[IDs.THUMBNAIL_WIDTH] = get(item, 'product.media.mainMedia.thumbnail.width'),
            _a[IDs.THUMBNAIL_HEIGHT] = get(item, 'product.media.mainMedia.thumbnail.height'),
            _a[IDs.THUMBNAIL_ALT] = get(item, 'product.media.mainMedia.thumbnail.alt'),
            _a[IDs.PRODUCT_PAGE_URL] = getProductFullUrl(item),
            _a[IDs.PRODUCT_PAGE_BASE_URL] = get(item, 'product.productPageUrl.base'),
            _a[IDs.DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a;
    },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
        return { tags: tags };
    },
    getBiData: function (item) {
        return {
            id: get(item, 'product.id'),
            name: get(item, 'product.name'),
        };
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
    getSlug: function (item) {
        return get(item, 'product.slug');
    },
    setFullUrl: function (itemData, url) {
        if (url === void 0) { url = ''; }
        itemData = JSON.parse(JSON.stringify(itemData));
        itemData.product.productPageUrl.path = url;
        return itemData;
    },
    getFullUrl: function (itemData) { return getProductFullUrl(itemData); },
    updateItemDataWithSlug: function (itemData, slugValue) {
        var updatedItemData = JSON.parse(JSON.stringify(itemData));
        if (get(updatedItemData, 'product.slug') !== '') {
            updatedItemData.product.slug = slugValue;
        }
        return updatedItemData;
    },
};
